import React, { useState, useEffect } from "react";
import { Button, Form, Popover } from "antd";
import { FormBox, InputBox } from "../../../../components/AntdAddons";
import LoginBanner from "../../../../assets/images/login-image.png";
import LoginBG from "../../../../assets/images/login-pattern.png";
import { Link, useNavigate, useParams } from "react-router-dom";
import { LoginRequest } from "../rules";
import { assignErrorToInput } from "../../../../store/api";
import { createPassword } from "../../../../store/AuthSlice";
import { useAppDispatch } from "../../../../utils/hooks/hooks";
import { formRules } from "../../../../config/validations/formRules";
import { Notification, base64EncodeDecode } from "../../../../config/Global";

/**
 * Renders the CreatePassword component.
 *
 * @return {ReactElement} The rendered CreatePassword component.
 */
const CreatePassword: React.FC = () => {
  const dispatch = useAppDispatch();
  const [form] = Form.useForm();
  const [saving, setSaving] = useState<boolean>(false);
  const [tooltip, setTooltip] = useState(false);
  const navigate = useNavigate();
  const { user_id }: any = useParams();
  const [decodedUserID, setDecodedUserID] = useState<any>(null);

  /**
 * Resets the user's password and navigates to the "/login" route on success,
 * throws an error on failure.
 *
 * @param {any} data - The data containing the new password.
 * @return {Promise<void>} A promise that resolves when the password is reset successfully.
 */


  useEffect(() => {
  
    setDecodedUserID(user_id);
  }, [])


  const changePassword = (data: any) => {
    localStorage.removeItem("token");
    setSaving(true);
    const requestData = {
      user_id: decodedUserID,
      new_password: data.password
    }
    dispatch(createPassword(requestData))
      .then(() => {
        navigate("/login");
      })
      .catch((error: any) => {
        assignErrorToInput(form, error?.STATUS);
      })
      .finally(() => setSaving(false));
  };

  const onChange = () => {
    form
      .validateFields(["password"])
      .then(() => {
        setTooltip(false);
      })
      .catch(() => {
        setTooltip(true);
      });
  };

  // password criteria tool tip
  const passwordTooltip = (
    <div>
      <div>at least 1 numeric character</div>
      <div>at least 1 special character</div>
      <div>at least 1 uppercase letter</div>
      <div>at least 8 character</div>
    </div>
  );

  return (
    <section className="loginSection">
      <div className="loginWrap">
        <div className="loginLogo">
          <div className="loginBanner">
            <img src={LoginBanner} alt="Banner" />
          </div>
        </div>
        <div
          className="loginForm"
          style={{ backgroundImage: `url(${LoginBG})` }}
        >
          <div className="loginFormWrap">
            <div className="formTitle">
              <h2>Create Password</h2>
            </div>
            <FormBox form={form} onFinish={changePassword} onChange={onChange}>
              <Popover
                placement="topRight"
                content={passwordTooltip}
                open={tooltip}
              >
                <InputBox.Password
                  name="password"
                  label="Password"
                  placeholder="xxxxxxx"
                  rules={formRules.password()}
                />
              </Popover>
              <InputBox.Password
                name="password_confirmation"
                label="Confirm Password"
                placeholder="xxxxxxx"
                rules={LoginRequest.confirmPassword()}
              />
              <div className="text-center resetPassword">
                <Button loading={saving} type="primary" htmlType="submit">
                  Create Password
                </Button>
              </div>
              <div className="text-right mt-10 font-medium login_extra_fields">
                <Link to="/login">Back to login</Link>
              </div>
            </FormBox>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CreatePassword;
